var map = {
	"./router_versionLog.js": "6O80"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BDGR";


//////////////////
// WEBPACK FOOTER
// ./src/pages/versionLog router_versionLog\.js$
// module id = BDGR
// module chunks = 65